import InvestmestIdDetails, { InvestmentIdDetails } from '../../src/pages/transact/invest';
import { InvestmentDetails } from '../pages/portfolio/profile';

export const getSelectedInvestmentIdWithName = (investmentId: string, investmentIds) => {
  const zerothID = investmentIds[0];
  let guardianName = zerothID.isMinor === 'N' ? zerothID.name : '';
  let matchInvestmentId = investmentIds.filter((id) => id.inv_ID == investmentId)[0];
  let labelString = '';
  if (matchInvestmentId.mode_of_oper_ac === 'AS') {
    let firstName =
      matchInvestmentId.name.split(' ')[0].length > 10
        ? matchInvestmentId.name.split(' ')[0].slice(0, 3)
        : matchInvestmentId.name.split(' ')[0];

    labelString = matchInvestmentId.inv_ID + ' - ' + firstName;

    if (matchInvestmentId.second_Holder_Name?.length) {
      let secondName =
        matchInvestmentId.second_Holder_Name.split(' ')[0].length > 10
          ? matchInvestmentId.second_Holder_Name.split(' ')[0].slice(0, 3)
          : matchInvestmentId.second_Holder_Name.split(' ')[0];
      labelString = labelString + '/ ' + secondName;
    }

    if (matchInvestmentId?.third_Holder_Name?.length) {
      let thirdName =
        matchInvestmentId.third_Holder_Name.split(' ')[0].length > 10
          ? matchInvestmentId.third_Holder_Name.split(' ')[0].slice(0, 3)
          : matchInvestmentId.third_Holder_Name.split(' ')[0];
      labelString = labelString + '/ ' + thirdName;
    }
  } else if (matchInvestmentId.isHUF === 'Y') {
    labelString = matchInvestmentId.inv_ID + ' - ' + matchInvestmentId.name.split(' ')[0] + ' ' + 'HUF';
  } else if (matchInvestmentId.isMinor == 'Y' && guardianName != '') {
    labelString =
      matchInvestmentId.inv_ID +
      ' - ' +
      matchInvestmentId.name.split(' ')[0] +
      ' ' +
      'U/G' +
      ' ' +
      guardianName.split(' ')[0];
  } else {
    labelString = matchInvestmentId.inv_ID + ' - ' + matchInvestmentId.name.split(' ')[0];
  }
  return { value: matchInvestmentId.inv_ID, label: labelString };
};

export const getInvestmentIdsOptionsWithName = (
  investmentIds: Array<InvestmentIdDetails> | Array<InvestmentDetails>
) => {
  const options = [];
  const zerothID = investmentIds[0];
  let guardianName = zerothID.isMinor === 'N' ? zerothID.name : '';
  investmentIds &&
    investmentIds.map((value, index) => {
      if (value.mode_of_oper_ac === 'AS') {
        let firstName =
          value.name.split(' ')[0].length > 10 ? value.name.split(' ')[0].slice(0, 3) : value.name.split(' ')[0];
        let secondName = '';
        if (value.second_Holder_Name?.length) {
          secondName =
            value.second_Holder_Name.split(' ')[0].length > 10
              ? value.second_Holder_Name.split(' ')[0].slice(0, 3)
              : value.second_Holder_Name.split(' ')[0];
        }

        if (value?.third_Holder_Name?.length) {
          let thirdName =
            value.third_Holder_Name.split(' ')[0].length > 10
              ? value.third_Holder_Name.split(' ')[0].slice(0, 3)
              : value.third_Holder_Name.split(' ')[0];
          options.push({
            value: value.inv_ID,
            label: value.inv_ID + ' - ' + firstName + '/ ' + secondName + '/ ' + thirdName,
          });
        } else if (secondName != '') {
          options.push({
            value: value.inv_ID,
            label: value.inv_ID + ' - ' + firstName + '/ ' + secondName,
          });
        } else {
          options.push({
            value: value.inv_ID,
            label: value.inv_ID + ' - ' + firstName,
          });
        }
      } else if (value.isHUF === 'Y') {
        options.push({
          value: value.inv_ID,
          label:
            value.inv_ID +
            ' - ' +
            (value.name.split(' ')[0] === '' ? value.name.split(' ')[2] : value.name.split(' ')[0]) +
            ' ' +
            'HUF',
          isHUF: value.isHUF,
          whetherMFTransactionAllowed: value.whetherMFTransactionAllowed,
          fatca_AVAILABLE: value.fatca_AVAILABLE,
          isUboApplicable: value.isUboApplicable,
        });
      } else if (value.isMinor == 'Y' && guardianName != '') {
        options.push({
          value: value.inv_ID,
          label: value.inv_ID + ' - ' + value.name.split(' ')[0] + ' ' + 'U/G' + ' ' + guardianName.split(' ')[0],
        });
      } else {
        options.push({
          value: value.inv_ID,
          label: value.inv_ID + ' - ' + value.name.split(' ')[0],
          isHUF: value.isHUF,
          whetherMFTransactionAllowed: value.whetherMFTransactionAllowed,
          fatca_AVAILABLE: value.fatca_AVAILABLE,
          isUboApplicable: value.isUboApplicable,
          isSoleProp: value?.isSoleProp,
          kycStatus: value?.kycStatus,
        });
      }
    });
  return options;
};
